import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ch0006',
    ecrans: ['00-2']
});
